<div class="popup-model popup-min shadow top">
  <div class="d-flex justify-content-between align-items-center pink-header P-2">
    <h5 class="flex-grow-1 text-center mt-1">{{'TIR.BLASTED' | translate}}</h5>
    <div data-svg-wrapper style="position: relative" class="p-1">
      <button class="btn p-0 d-flex align-items-center" (click)="onClose()">
        <img src="assets/icon/close.svg" />
      </button>
    </div>
  </div>
  <div  class="p-4 scrollable-container">
    <div class="row mb-3">
      <div class="col-md-6">
        <div class="form-group">
          <label class="form-label">{{'TIR.REAL_DATE' | translate}} <span class="text-danger">*</span> </label>
          <input 
            type="date" 
            class="form-control" 
            [(ngModel)]="blastDate"
            required>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label class="form-label">{{'TIR.TIME' | translate}} <span class="text-danger">*</span> </label>
          <input 
            type="time" 
            class="form-control" 
            [(ngModel)]="blastTime"
            required>
        </div>
      </div>
    </div>

    <div class="text-center mb-3">
      <p class="mb-0">{{'TIR.CONFIRM_MARK_BLASTED' | translate}}</p>
    </div>

    <div class="d-flex justify-content-center pt-3" style="gap: 20px;">
      <button type="button" class="btn btn-outline-primary"
        (click)="onClose()">{{'GLOBAL.ANNULER' | translate}}</button>
      <button type="submit" class="btn primary-button" (click)="updateBlastedStatus()"
        >{{'GLOBAL.CONFIRMER' | translate}}</button>
    </div>
</div>
</div>
